// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WSPackages_root__CeQP7 {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(214, 186, 115, 0.8);
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 9999999;
  padding: 10px;
  font-size: 16px;
}

.WSPackages_item__rOfwZ {
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 5px;
}
.WSPackages_item__date__QFyDH {
  font-size: 0.75em;
  margin-bottom: 4px;
  font-style: italic;
}
.WSPackages_item__type__BkUvv {
  font-style: normal;
  font-size: 1em;
  font-weight: 600;
  margin-left: 18px;
}
.WSPackages_item__body__QbiGQ {
  font-size: 0.75em;
}
.WSPackages_itemIn__7TVGY {
  color: white;
  background: black;
}
.WSPackages_itemOut__IvMc4 {
  color: black;
  background: white;
}

.WSPackages_clear__\\+72Jg {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 6px;
  border: 0;
  background: #F5E0B7;
  border-radius: 4px;
  cursor: pointer;
}

.WSPackages_close__rY5W6 {
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 6px;
  border: 0;
  background: #F5E0B7;
  border-radius: 4px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/_debug/WSPackages/WSPackages.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;EAEA,WAAA;EACA,YAAA;EAEA,cAAA;EACA,gBAAA;EACA,aAAA;EAEA,eAAA;AAFF;;AAKA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;AAFF;AAIE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,kBAAA;EAEA,cAAA;EAEA,gBAAA;EACA,iBAAA;AALJ;AAQE;EACE,iBAAA;AANJ;AASE;EAEE,YAAA;EACA,iBAAA;AARJ;AAWE;EACE,YAAA;EACA,iBAAA;AATJ;;AAaA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAEA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAXF;;AAeA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EAEA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAbF","sourcesContent":[".root {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(214, 186, 115, 0.8);\n\n  width: 100%;\n  height: 100%;\n\n  overflow: auto;\n  z-index: 9999999;\n  padding: 10px;\n\n  font-size: 16px;\n}\n\n.item {\n  border-radius: 10px;\n  padding: 5px;\n  margin-bottom: 5px;\n\n  &__date {\n    font-size: 0.75em;\n    margin-bottom: 4px;\n    font-style: italic;\n  }\n\n  &__type {\n    font-style: normal;\n    //color: #F5E0B7;\n    font-size: 1em;\n\n    font-weight: 600;\n    margin-left: 18px;\n  }\n\n  &__body {\n    font-size: 0.75em;\n  }\n\n  &In {\n    //color: white;\n    color: white;\n    background: black;//#8BBF9F;\n  }\n\n  &Out {\n    color: black;\n    background: white;// #59344F;\n  }\n}\n\n.clear {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  padding: 6px;\n\n  border: 0;\n  background: #F5E0B7;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n.close {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  padding: 6px;\n\n  border: 0;\n  background: #F5E0B7;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `WSPackages_root__CeQP7`,
	"item": `WSPackages_item__rOfwZ`,
	"item__date": `WSPackages_item__date__QFyDH`,
	"item__type": `WSPackages_item__type__BkUvv`,
	"item__body": `WSPackages_item__body__QbiGQ`,
	"itemIn": `WSPackages_itemIn__7TVGY`,
	"itemOut": `WSPackages_itemOut__IvMc4`,
	"clear": `WSPackages_clear__+72Jg`,
	"close": `WSPackages_close__rY5W6`
};
export default ___CSS_LOADER_EXPORT___;
